let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("khrIN")).then(() => parcelRequire('h4j8A'));